'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _object = require('object.values');

var _object2 = _interopRequireDefault(_object);

var _getUTMFirst = require('../cookie/getUTMFirst');

var _getUTMFirst2 = _interopRequireDefault(_getUTMFirst);

var _setUTMFirst = require('../cookie/setUTMFirst');

var _setUTMFirst2 = _interopRequireDefault(_setUTMFirst);

var _setUTMLast = require('../cookie/setUTMLast');

var _setUTMLast2 = _interopRequireDefault(_setUTMLast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setUTMParams(query) {
    /* eslint-disable camelcase */
    var _qs$parse = _qs2.default.parse(query),
        _qs$parse$utm_source = _qs$parse.utm_source,
        utm_source = _qs$parse$utm_source === undefined ? '' : _qs$parse$utm_source,
        _qs$parse$utm_medium = _qs$parse.utm_medium,
        utm_medium = _qs$parse$utm_medium === undefined ? '' : _qs$parse$utm_medium,
        _qs$parse$utm_campaig = _qs$parse.utm_campaign,
        utm_campaign = _qs$parse$utm_campaig === undefined ? '' : _qs$parse$utm_campaig,
        _qs$parse$utm_term = _qs$parse.utm_term,
        utm_term = _qs$parse$utm_term === undefined ? '' : _qs$parse$utm_term,
        _qs$parse$utm_content = _qs$parse.utm_content,
        utm_content = _qs$parse$utm_content === undefined ? '' : _qs$parse$utm_content;

    /* eslint-enable camelcase */


    var utmCurrent = {
        utm_source: utm_source,
        utm_medium: utm_medium,
        utm_campaign: utm_campaign,
        utm_term: utm_term,
        utm_content: utm_content
    };

    if (!Object.values) {
        _object2.default.shim();
    }

    if (Object.values(utmCurrent).some(function (value) {
        return !!value;
    })) {
        if (!(0, _getUTMFirst2.default)()) {
            (0, _setUTMFirst2.default)(utmCurrent);
        } else {
            (0, _setUTMLast2.default)(utmCurrent);
        }
    }
}

exports.default = setUTMParams;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/utils/utm/setUTMParams.js
// module id = 1053
// module chunks = 0